module.exports = __webpack_public_path__ + "img/f8.e1d4fbbe.jpg";